// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"layout_pageWrap__3ywsa","land":"layout_land__1ZpLC","FooterLogo":"layout_FooterLogo__28lLt","subpage":"layout_subpage__AzmiQ"};